<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年01月07日 18:23:14 +0800
 * @最后修改时间: 2022-02-18 11:36:48
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Site\siteType\newSiteType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_siteType_form_newTitle')"
    widthClass="max-1000"
    :initData="siteTypeData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'site_type_abbr',
      'site_type_code',
      'site_type_description',
      'site_type_name',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteTypeData.site_type_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_siteTypeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteTypeData.site_type_abbr"
              maxlength="20"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_siteTypeAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <normalInputTextFiled
              v-model="siteTypeData.site_type_code"
              maxlength="20"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="siteTypeData.site_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_siteType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              dense
              single-line
              filled
              counter="500"
              v-model="siteTypeData.remarks"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toAddSiteType" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newSiteType",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      isChanged: false,
      siteTypeData: {
        site_type_abbr: "",
        site_type_code: "",
        site_type_description: "",
        site_type_name: "",
        remarks: "",
      },
    };
  },
  mounted() {
    this.siteTypeData.site_type_name = this.$getCommonLangKey(this.companyLang);
    this.siteTypeData.site_type_abbr = this.$getCommonLangKey(this.companyLang);
    this.siteTypeData.site_type_description = this.$getCommonLangKey(
      this.companyLang
    );
  },
  methods: {
    toAddSiteType: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/add-site-type-table/",
        data: {
          site_type_abbr: this.$transCommonLangKey(
            this.siteTypeData.site_type_abbr
          ),
          site_type_description: this.$transCommonLangKey(
            this.siteTypeData.site_type_description
          ),
          site_type_name: this.$transCommonLangKey(
            this.siteTypeData.site_type_name
          ),
          site_type_code: this.siteTypeData.site_type_code,
          remarks: this.siteTypeData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
